<img class="avatar avatar--hover avatare-large" src="{{avatar}}" alt="User: {{firstName}} {{secondName}}" width="44"
  height="44">